import { useMemo } from 'react';
import { useBannerUserActions } from './promotionalBanner';

const DASHBOARD_FEATURE = 'dashboards';
const INTERESTED_ACTION = 'interested';

export type DashboardAccessState = 'loading' | 'allowed' | 'denied';

export const useDashboardAccess = () => {
    const {
        bannerUserActions,
        isLoading,
        isError,
        hasCheckedAPI,
        refetch,
    } = useBannerUserActions();

    const access = useMemo<DashboardAccessState>(() => {
        if (isLoading || !hasCheckedAPI) {
            return 'loading';
        }

        const hasAccess = (bannerUserActions ?? []).some(
            action =>
                action.feature === DASHBOARD_FEATURE &&
                action.action === INTERESTED_ACTION
        );

        return hasAccess ? 'allowed' : 'denied';
    }, [bannerUserActions, isLoading, hasCheckedAPI]);

    return {
        access,
        hasDashboardAccess: access === 'allowed',
        isLoading: access === 'loading',
        isError,
        refetch,
    };
};
